// UX46: catch-up strip for return visits.
//
// Lives above the feed, shows how many new polls have arrived since
// the user's previous visit. Non-blocking — a single line with a
// Dismiss affordance. Auto-dismisses the moment the user votes on
// anything, so it never lingers once they've engaged.
//
// Rendered only when:
//   • not the user's first visit (so new users don't get a confused
//     "5 new polls since your last visit" with nothing to compare to)
//   • at least one feed item is newer than the stored lastSeen
//   • user hasn't dismissed in this session

export function CatchUpCard({ count, onDismiss }) {
  if (!count || count < 1) return null
  return (
    <div className="catch-up-card" role="status" aria-live="polite">
      <span className="catch-up-text">
        <span aria-hidden="true">✨ </span>
        <strong>{count} new {count === 1 ? 'poll' : 'polls'}</strong>
        {' '}since you were last here
      </span>
      <button
        type="button"
        className="catch-up-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss catch-up card"
      >
        ×
      </button>
    </div>
  )
}
